/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Status_CompleteInputs */

const en_sync_status_complete = /** @type {(inputs: Sync_Status_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Business Central`)
};

/**
* | output |
* | --- |
* | "In Business Central" |
*
* @param {Sync_Status_CompleteInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_status_complete = /** @type {((inputs?: Sync_Status_CompleteInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Status_CompleteInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_status_complete(inputs)
});